import { render, staticRenderFns } from "./HowItWorkLeft.vue?vue&type=template&id=c85ad278&scoped=true&"
import script from "./HowItWorkLeft.vue?vue&type=script&lang=js&"
export * from "./HowItWorkLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ad278",
  null
  
)

export default component.exports